module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views/~/babel-runtime/core-js/object/get-prototype-of.js
// module id = 3491
// module chunks = 0